import * as React from 'react';
import Icon from 'components/Icon';

export interface LoadingScreenProps {
  title: string;
  message: string;
  action?: React.ReactNode;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ title, message, action }) => {
  return (
    <div className="ex3d-brand-page-background flex size-full flex-col items-center justify-center px-6 py-4">
      <Icon className="ex3d-icon--car size-8 animate-bounce" />
      <h1 className="text-center text-base font-bold sm:text-xl">{title}</h1>
      <p className="max-w-lg text-center text-sm sm:text-base">{message}</p>
      {action}
    </div>
  );
};

LoadingScreen.displayName = 'LoadingScreen';
